module.exports = __webpack_public_path__ + "static/img/smile5.fbbf05f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile5.jpg
// module id = 179
// module chunks = 2